var Icons;
(function (Icons) {
    Icons["FACEBOOK"] = "fa-brands fa-facebook";
    Icons["INSTAGRAM"] = "fa-brands fa-instagram";
    Icons["PINTEREST"] = "fa-brands fa-pinterest";
    Icons["YOUTUBE"] = "fa-brands fa-youtube";
    Icons["TWITTER"] = "fa-brands fa-x-twitter";
    Icons["DRUPAL"] = "fa-brands fa-drupal";
    Icons["MAGENTO"] = "fa-brands fa-magento";
    Icons["WORDPRESS"] = "fa-brands fa-wordpress";
    Icons["CAMERA"] = "fa-camera";
    Icons["PANORAMA"] = "fa-panorama";
    Icons["IMAGE"] = "fa-image";
    Icons["PORTRAIT"] = "fa-image-portrait";
})(Icons || (Icons = {}));
var DEFAULT_ICON = Icons.IMAGE;

export { DEFAULT_ICON, Icons };
//# sourceMappingURL=utils.js.map
